export default "__VITE_ASSET__DEFv_Sxu__"